import React, { useState } from 'react';
import { observer } from 'mobx-react-lite';
import { Swiper, SwiperSlide } from 'swiper/react';
import { SVGPureIcon } from '@/ui';
import { HelperCore, HelpOther } from '@/common/helper';
import client from '@/store/client';

import './index.scss';

const name = 'xiaohongshu-media';

const MediaCard = ({ data }) => {
  const { cover, link, title, url, contentType } = data;

  /** 下载视频资源 */
  const handledownload = async e => {
    e.stopPropagation();
    if (!url) {
      HelpOther.toast('无法下载');
      return;
    }
    const blob = await fetch(url)
      .then(res => res.blob())
      .catch(err => null);
    if (blob) {
      const url = URL.createObjectURL(blob);
      HelperCore.saveFile(url, title);
    } else {
      HelpOther.toast('无法下载');
    }
  };

  /** 跳转 */
  const handleJump = (e) => {
    e.stopPropagation();
    if (!link) {
      HelpOther.toast('无法跳转');
      return;
    }
    client.openPage(link);
  };

  return (
    <div className="xiaohongshu-card group w-full mx-8px cursor-pointer" onClick={handleJump}>
      <div className="w-full h-168px relative rounded-12px overflow-hidden bg-[#F7F7F7]">
        <img className="w-full h-full object-contain" src={cover} alt="" />
        {contentType === 'video' ? (
          <span
            name="icon_download"
            className="size-16px absolute top-8px right-4px"
            style={{
              background: 'url(https://p3.ssl.qhimg.com/t110b9a9301135253078dd0dea4.png) no-repeat center center/cover',
            }}
          />
        ) : null}

        {/* hover蒙层 */}
        <div
          className={[
            'w-full h-60px pt-19px absolute left-0 z-1 flex justify-center items-start gap-10px overflow-hidden',
            'group-hover:bottom-0 bottom-[-60px] transition-all duration-500 ease-in-out',
          ]}
          style={{
            background:
              'linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.4) 100%)',
          }}
        >
          <span
            className="h-28px w-72px flex items-center justify-center text-white text-12px bg-black bg-opacity-70 hover:bg-opacity-100 rounded-14px"
            onClick={handleJump}
          >
            访问来源
          </span>
          {url && (
            <span
              onClick={handledownload}
              className="size-28px flex items-center justify-center !text-white text-12px !bg-black !bg-opacity-70 !hover:bg-opacity-100 rounded-full"
            >
              <SVGPureIcon name="icon_download" className="size-20px" />
            </span>
          )}
        </div>
      </div>
    </div>
  );
};

const XiaohongshuMedia = props => {
  const { list = [], notesNum } = props;
  const [isFold, setFold] = useState(false);

  const handleFold = () => {
    setFold(_ => !_);
  };

  if (!list?.length) return null;

  return (
    <div
      className={[
        'w-[80%] rounded-12px bg-white p-16px mt-16px border-[1px] border-[rgba(0, 0, 0, 0.1)]',
        `${isFold ? 'h-60px' : 'h-246px'} transition-all duration-200 ease-in-out overflow-hidden`,
      ]}
    >
      <h3 className="h-28px mb-0 flex justify-between items-center text-16px text-black font-bold-600">
        {notesNum || 0}篇小红书笔记中的优质参考素材
        <div
          className={[
            `size-18px flex items-center justify-center cursor-pointer`,
            `transition-transform transition-[0.25s] transform ${isFold ? '' : 'rotate-[180deg]'}`,
          ]}
          onClick={handleFold}
        >
          <SVGPureIcon
            name="fold"
            className="w-full h-full opacity-50 text-primary-opacity hover:opacity-70"
          />
        </div>
      </h3>

      {/* 轮播 */}
      <div className={`relative xiaohongshu-swiper`}>
        <Swiper
          className="w-full mt-16px"
          direction="horizontal"
          slidesPerView={'auto'}
          slidesPerGroup={3}
          spaceBetween={16}
          navigation={{
            prevEl: `.swiper-btn-prev-${name}`,
            nextEl: `.swiper-btn-next-${name}`,
          }}
        >
          {list.map((item, index) => {
            return (
              <SwiperSlide key={index + item.cover} className="!w-126px">
                <MediaCard data={item} />
              </SwiperSlide>
            );
          })}
          <div
            className="mask w-62px h-full absolute top-0 right-0"
            style={{
              background:
                'linear-gradient(90deg, rgba(255, 255, 255, 0.00) 5%, #FFF 100%)',
            }}
          ></div>
        </Swiper>
        <div className="text-[rgba(0,0,0,0.5)]">
          <div
            className={[
              `swiper-btn-prev-${name} vh-center size-32px rounded-full`,
              'absolute top-1/2 -left-8px -mt-16px',
              'border-1px border-[rgba(0,0,0,0.1)] bg-white hover:bg-[#f7f7f7]  cursor-pointer',
            ]}
          >
            <SVGPureIcon name="swiper_agent_prev" className="size-21px" />
          </div>
          <div
            className={[
              `swiper-btn-next-${name} vh-center size-32px rounded-full`,
              'absolute top-1/2 -right-8px -mt-16px',
              'border-1px border-[rgba(0,0,0,0.1)] bg-white hover:bg-[#f7f7f7]  cursor-pointer',
            ]}
          >
            <SVGPureIcon name="swiper_agent_next" className="size-21px" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default observer(XiaohongshuMedia);
